import {dialogTriggerClickHandler} from '../base';

/**
 * Диалоговое модальное окно.
 * Поддерживает автоматическое открытие и открытие по клику на триггер.
 *
 * @class DialogModal
 */
class DialogModal {
    /**
     * @param {string} props.dialogSelector - селектор элемента dialog.
     * @param {string} props.dialogOpenTrigger - селектор элементов-триггеров для открытия.
     * @param {Object} props.settings - настройки модального окна.
     * @param {boolean} props.settings.autoOpen - Автоматически открывать диалог при загрузке.
     * @param {number} props.settings.timeout - Задержка автооткрытия (мс).
     * @param {string} props.settings.stopAutoOpenSessionKey - Ключ sessionStorage для блокировки повторного автооткрытия.
     * @param {Function} props.settings.callbackByOpen - Callback при открытии диалога.
     */
    constructor(props) {
        this.dialog = document.querySelector(props.dialogSelector);
        this.triggers = document.querySelectorAll(props.dialogOpenTrigger);
        this.settings = props.settings;

        this.initializeDialog();
    }

    /**
     * Инициализирует диалог: автооткрытие или привязку к триггерам.
     * @returns {void}
     */
    initializeDialog() {
        if (!this.dialog) {
            return;
        }

        const isAutoOpenAvailable = !this.checkDialogOpened() && this.settings?.autoOpen;

        !isAutoOpenAvailable
            ? this.handleDialogOpenByTrigger()
            : setTimeout(() => {
                  dialogTriggerClickHandler(null, this.dialog, this.settings?.callbackByOpen);
              }, this.settings.timeout);
    }

    /**
     * Добавляет обработчики клика на элементы-триггеры для открытия диалога.
     * @returns {void}
     */
    handleDialogOpenByTrigger() {
        if (!this.triggers) {
            return;
        }

        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                dialogTriggerClickHandler(event, this.dialog, this.settings?.callbackByOpen);
            });
        });
    }

    /**
     * Проверяет, был ли диалог уже открыт в текущей сессии (через sessionStorage).
     * @returns {boolean|string|null} Значение из sessionStorage или false, если ключ не задан.
     */
    checkDialogOpened() {
        const sessionStopKey = this.settings?.stopAutoOpenSessionKey;

        return sessionStopKey ? sessionStorage.getItem(sessionStopKey) : false;
    }
}

export default DialogModal;
